<template>
  <q-list>
    <q-item v-for="(slider, index) in sliders" :key="slider.player">
      <span class="slider_back_name" :class=" slider.color ">{{ columns[index].label }}</span> <q-btn flat style="padding-top:0; padding-bottom:0" size="0.8rem" color="deep-orange-3" @click="minus(slider.player)" :repeat-timeout="100" icon="fas fa-minus-circle" />
      <q-item-main>
        <q-slider
        :value="tableLastRowVal(slider.player)"
        @change="val => { changeData(val, slider.player); autoInputLastData(slider.player) }"
        :min="-100" :max="50"
        label
        :color="slider.color"
        />
      </q-item-main>
      <q-btn flat style="padding-top:0; padding-bottom:0" size="0.8rem" color="cyan-3" @click="plus(slider.player)" :repeat-timeout="100" icon="fas fa-plus-circle" />
    </q-item>
  </q-list>
</template>

<style lang="scss">
  .slider_back_name {
    position: absolute;
    opacity: 0.4;
    padding-bottom: 30px;
    font-weight: bold;
    margin-left: 100px;
  }
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
// mapActions
export default {
  methods: {
    ...mapMutations('ScoreTable', {
      changeLastRow: 'changeLastRow',
      decrement: 'decrementLastRowCell',
      increment: 'incrementLastRowCell'
    }),
    ...mapMutations('TheScoreSlider', {
      toSanma: 'toSanma',
      toYonma: 'toYonma'
    }),
    changeData (val, player) {
      let changeObj = {val: val, player: player}
      this.changeLastRow(changeObj)
    },
    autoInputLastData (inputPlayer) {
      let zeroCount = 0
      let zeroPlayer = ''
      for (let key in this.tableLastRow) {
        if (key === '__index') {
          continue
        }
        if (this.tableLastRow[key] === 0) {
          ++zeroCount
          zeroPlayer = key
        }
      }
      if (zeroCount === 1 && zeroPlayer !== inputPlayer) {
        // auto input
        let sum = 0
        for (let key in this.tableLastRow) {
          if (key === '__index') {
            continue
          }
          sum += this.tableLastRow[key]
        }
        this.changeData(-sum, zeroPlayer)
        return
      }

      if (zeroCount === 0) {
        this.changeTopData(inputPlayer)
      }
    },
    changeTopData (inputPlayer) {
      let maxPoint = -99999
      let maxPointPlayer = ''
      for (let key in this.tableLastRow) {
        if (key === '__index') {
          continue
        }
        if (this.tableLastRow[key] > maxPoint) {
          maxPoint = this.tableLastRow[key]
          maxPointPlayer = key
        }
      }
      // if it's myself do nothing
      if (maxPointPlayer === inputPlayer) {
        return
      }

      // auto input
      let sum = 0
      for (let key in this.tableLastRow) {
        if (key === maxPointPlayer || key === '__index') {
          continue
        }
        sum += this.tableLastRow[key]
      }
      this.changeData(-sum, maxPointPlayer)
    },
    plus: function (player) {
      this.increment({player: player})
      this.autoInputLastData(player)
    },
    minus: function (player) {
      this.decrement({player: player})
      this.autoInputLastData(player)
    }
  },
  computed: {
    ...mapGetters('TheScoreSlider', {
      sliders: 'getSliders'
    }),
    ...mapGetters('ScoreTable', {
      tableData: 'getTableData',
      columns: 'getColumns',
      tableLastRow: 'getLastRow',
      tableLastRowVal: 'getLastRowPlayerVal',
      isSanma: 'getIsSanma'
    })
  },
  watch: {
    isSanma () {
      if (this.isSanma) {
        this.toSanma()
      } else {
        this.toYonma()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TheScoreSlider.vue